export const isResellerCodeValid = (value: string) => /^\d{1,8}$/.test(value);
